module.exports = {
	"genre": {
		"genre-id-1": "Altri generi",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Country",
		"genre-id-5": "Folk",
		"genre-id-6": "Musica francese",
		"genre-id-7": "Interpreti di Musica francese",
		"genre-id-8": "Musica francese retrò",
		"genre-id-9": "Rock francese",
		"genre-id-10": "Classica",
		"genre-id-11": "Elettronica",
		"genre-id-12": "Musique concrète",
		"genre-id-13": "Elettronica",
		"genre-id-14": "Musica minimalista",
		"genre-id-15": "Mélodies & Lieder",
		"genre-id-16": "Lieder (Germania)",
		"genre-id-17": "Lieder",
		"genre-id-18": "Mélodies",
		"genre-id-19": "Mélodies (Inghilterra)",
		"genre-id-20": "Mélodies (Nord Europa)",
		"genre-id-21": "Mélodies (Francia)",
		"genre-id-22": "Concerto",
		"genre-id-23": "Altri strumenti",
		"genre-id-24": "Concerti per clavicembalo",
		"genre-id-25": "Concerti per violino",
		"genre-id-26": "Concerti per violoncello",
		"genre-id-27": "Musica da camera",
		"genre-id-28": "Altre formazioni",
		"genre-id-29": "Altri strumenti solisti",
		"genre-id-30": "Pianoforte solista",
		"genre-id-31": "Quartetti",
		"genre-id-32": "Quintetti",
		"genre-id-33": "Duo",
		"genre-id-34": "Trio",
		"genre-id-35": "Violino solista",
		"genre-id-36": "Violoncello solista",
		"genre-id-37": "Musica sinfonica",
		"genre-id-38": "Balletto",
		"genre-id-39": "Musica di scena",
		"genre-id-40": "Musiche per il cinema",
		"genre-id-41": "Ouverture",
		"genre-id-42": "Poesie sinfoniche",
		"genre-id-43": "Sinfonie",
		"genre-id-44": "Musiche vocali (sacre e profane)",
		"genre-id-45": "Cantate (profane)",
		"genre-id-46": "Musica corale",
		"genre-id-47": "Musiche per gruppi vocali",
		"genre-id-48": "Oratori profani",
		"genre-id-49": "Recital vocali",
		"genre-id-50": "Musiche vocali (sacre)",
		"genre-id-51": "Cantate sacre",
		"genre-id-52": "Cori sacri",
		"genre-id-53": "Messe, Passioni, Requiem",
		"genre-id-54": "Oratori sacri",
		"genre-id-55": "Opera",
		"genre-id-56": "Estratti d'Opera",
		"genre-id-57": "Opera integrale",
		"genre-id-58": "Operetta",
		"genre-id-59": "Audiolibri",
		"genre-id-60": "Pedagogia",
		"genre-id-61": "Documenti storici",
		"genre-id-62": "Humor",
		"genre-id-63": "Letteratura",
		"genre-id-64": "Elettronica",
		"genre-id-65": "Ambient",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum & Bass",
		"genre-id-68": "House",
		"genre-id-69": "Lounge",
		"genre-id-70": "Techno",
		"genre-id-71": "Trance",
		"genre-id-72": "Trip Hop",
		"genre-id-73": "Atmosfere per l'infanzia",
		"genre-id-74": "Fisarmonica",
		"genre-id-75": "Racconti e favole",
		"genre-id-76": "Educativo",
		"genre-id-77": "Karaoke",
		"genre-id-78": "Musica militare",
		"genre-id-79": "Relax",
		"genre-id-80": "Jazz",
		"genre-id-81": "Be Bop",
		"genre-id-82": "Cool jazz",
		"genre-id-83": "Free jazz & Avanguardia",
		"genre-id-84": "Gospel",
		"genre-id-85": "Jazz contemporaneo",
		"genre-id-86": "Jazz fusion & Jazz rock",
		"genre-id-87": "Jazz manouche",
		"genre-id-88": "Jazz tradizionale & New Orleans",
		"genre-id-89": "Jazz vocale",
		"genre-id-90": "Jazz latino",
		"genre-id-91": "Colonne sonore",
		"genre-id-92": "Colonne sonore",
		"genre-id-93": "Commedie musicali",
		"genre-id-94": "World music",
		"genre-id-95": "Africa",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Asia",
		"genre-id-98": "Brasile",
		"genre-id-99": "Celtica",
		"genre-id-100": "Est Europa",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Musica etnica",
		"genre-id-104": "Musica indiana",
		"genre-id-105": "Oriente",
		"genre-id-106": "Raï",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "World Music",
		"genre-id-110": "Yiddish & Klezmer",
		"genre-id-111": "Zouk & Antille",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternative & Indie",
		"genre-id-114": "Crooners",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Pop",
		"genre-id-118": "Punk - New Wave",
		"genre-id-119": "Rock",
		"genre-id-120": "Progressive rock",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "Varietà internazionale",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall reggae",
		"genre-id-125": "Dub",
		"genre-id-126": "Ska & Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Acid jazz",
		"genre-id-129": "Dance",
		"genre-id-130": "Disco",
		"genre-id-131": "Funk",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Soul",
		"genre-id-135": "Operetta",
		"genre-id-137": "Concerto per tromba",
		"genre-id-138": "Concerti per fiati",
		"genre-id-139": "Crossover",
		"genre-id-140": "Documenti",
		"genre-id-141": "New Age",
		"genre-id-142": "Atmosfere",
		"genre-id-144": "Crossover",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "Tv Series",
		"genre-id-148": "Videogiochi",
		"genre-id-149": "Latina",
		"genre-id-150": "Nord America",
		"genre-id-151": "Europa",
		"genre-id-152": "Gipsy",
		"genre-id-153": "Musica tradizionale",
		"genre-id-154": "Maghreb",
		"genre-id-155": "Russia",
		"genre-id-156": "Turchia",
		"genre-id-157": "Indie pop",
		"genre-id-158": "Ballate comiche",
		"genre-id-159": "Musica di natale",
		"genre-id-160": "Germania",
		"genre-id-161": "Scozia",
		"genre-id-162": "Spagna",
		"genre-id-163": "Grecia",
		"genre-id-164": "Irlanda",
		"genre-id-165": "Canzone italiana",
		"genre-id-166": "Portogallo",
		"genre-id-167": "Infanzia",
		"genre-id-176": "Musica vocale profana",
		"genre-id-173": "Schlager (Germania)",
		"genre-id-171": "Stimmungsmusik (Germania)",
		"genre-id-172": "Volksmusik (Germania)",
		"genre-id-174": "Celtica irlandese",
		"genre-id-175": "Pop irlandese",
		"genre-id-168": "Folklore svizzero",
		"genre-id-178": "Tedesco",
		"genre-id-177": "Inglese",
		"genre-id-170": "Francese",
		"genre-id-179": "Olandese",
		"genre-id-180": "Bolero",
		"genre-id-181": "Urban Latina",
		"genre-id-182": "Reggaeton",
		"genre-id-183": "MPB - Música Popular Brasileira",
		"genre-id-184": "Bossa Nova",
		"genre-id-185": "Samba",
		"genre-id-186": "Forró",
		"genre-id-187": "Pagode",
		"genre-id-188": "Funk Brasiliano",
		"genre-id-189": "Sertanejo",
		"genre-id-190": "Musica giapponese",
		"genre-id-191": "J-Pop",
		"genre-id-192": "Musica tradizionale giapponese",
		"genre-id-193": "Musica coreana",
		"genre-id-194": "K-Pop",
		"genre-id-195": "Musica tradizionale coreana",
		"genre-id-196": "Anime/Videogiochi",
		"genre-id-197": "Anime"
	},
	"article-cat": {
		"article-cat-2": "-- ARCHIVI GENERALI --",
		"article-cat-4": "Incontri",
		"article-cat-5": "-- ARCHIVES GER / LIRE / CLASSICA --",
		"article-cat-7": "Dal vivo",
		"article-cat-8": "Premi",
		"article-cat-10": "Nei Media",
		"article-cat-22": "Necrologi",
		"article-cat-51": "Discografia",
		"article-cat-53": "Bibliografia",
		"article-cat-54": "Ritratti",
		"article-cat-97": "Attualità",
		"article-cat-98": "Rubriche principali",
		"article-cat-100": "Industria",
		"article-cat-101": "Novità",
		"article-cat-117": "JazzNews",
		"article-cat-122": "Attualità",
		"article-cat-189": "Intervista",
		"article-cat-197": "Ascolto comparato",
		"article-cat-199": "Incontri",
		"article-cat-209": "J'ai la mémoire qui chante",
		"article-cat-226": "Cave Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Peux-tu ?",
		"article-cat-238": "Magazine: critica",
		"article-cat-252": "Callassotherapy",
		"article-cat-260": "Le symphoman",
		"article-cat-267": "Croisées",
		"article-cat-279": "Concerti",
		"article-cat-286": "Confidenziale",
		"article-cat-287": "Agenda",
		"article-cat-293": "Eventi",
		"article-cat-295": "Concerti e Tour",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Test Hi-Fi",
		"article-cat-299": "Pratica",
		"article-cat-301": "Attualità",
		"article-cat-302": "Registrazioni del suono d'eccezione",
		"article-cat-303": "Les Magiciens du Son",
		"article-cat-304": "Trax",
		"article-cat-305": "Della cera vecchia in orecchie pulite",
		"article-cat-306": "Voxpop",
		"article-cat-311": "Orchestra filarmonica di Berlino",
		"article-cat-312": "André Tubeuf: Memoria e paesaggi ",
		"article-cat-315": "François Hudry: Cum grano salis",
		"article-cat-316": "Qibuz Classica",
		"article-cat-318": "L'editoriale",
		"article-cat-319": "Qobuz a",
		"article-cat-320": "Marsiglia",
		"article-cat-321": "Festival Paris Baroque",
		"article-cat-322": "I matti della Hi-Fi",
		"article-cat-323": "Rennes",
		"article-cat-324": "Editoriali",
		"article-cat-325": "Qobuz",
		"article-cat-326": "L'editoriale di Jean-Michel Proust",
		"article-cat-327": "Jean-Michel Proust : l'attualità del mese",
		"article-cat-328": "Qibuz Lunedï",
		"article-cat-329": "Lille",
		"article-cat-330": "Yes Masters!",
		"article-cat-331": "Il minuto Qobuz",
		"article-cat-332": "Moderno",
		"article-cat-333": "Newsletter",
		"article-cat-334": "Newsletter Qobuz Streaming",
		"article-cat-335": "Newsletter Promozioni",
		"article-cat-336": "Newsletter Qobuz Hi-Fi",
		"article-cat-337": "Newsletter Classica",
		"article-cat-339": "Newsletter Electro",
		"article-cat-340": "Newsletter Infanzia",
		"article-cat-341": "Newsletter Spoken Word",
		"article-cat-342": "Smartphones compatibili con audio HD",
		"article-cat-343": "Newsletter Musica francese",
		"article-cat-344": "France Musique",
		"article-cat-345": "Stile Moderno",
		"article-cat-347": "Newsletter Atmosfera",
		"article-cat-350": "In inglese",
		"article-cat-351": "In tedesco",
		"article-cat-352": "In olandese",
		"article-cat-353": "In inglese",
		"article-cat-354": "In tedesco",
		"article-cat-355": "In olandese",
		"article-cat-356": "In olandese",
		"article-cat-357": "In tedesco",
		"article-cat-358": "In inglese",
		"article-cat-359": "Vieux Sequins et Vieilles Cuirasses",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Tutorials",
		"article-cat-362": "Novità Classica",
		"article-cat-363": "Studio Qobuz",
		"article-cat-364": "Studio Qobuz",
		"article-cat-365": "In evidenza",
		"article-cat-368": "Archivi",
		"article-cat-369": "Qobuz Chef",
		"article-cat-370": "One Cover/One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiIt.json
// module id = 560
// module chunks = 0